import { http } from '@/providers/apis/http';
import { topicListSerializer } from '@/providers/serializers/topic-list/topic-list';
export class TopicListAPI {

    private static INSTANCE = new TopicListAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace = 'api/mygooru/chatbot/v1/ai';

    private adminNamespace = 'api/v1/admin-utils';

    private markerNamespace = 'api/v1';

    public getTopics(params: any) {
        const endpoint = `${this.namespace}/tenant/topics`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header, params).then((response) => {
            return topicListSerializer.serializeTopicList(response.data);
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public getTopicsBySubject(params: any) {
        const subjectCode = params.subjectCode;
        const levelId = params.levelId;
        const endpoint = `${this.namespace}/tenant/subjects/${subjectCode}/level/${levelId}/topics`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return topicListSerializer.serializeTopicList(response.data);
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public getSubjects() {
        const endpoint = `${this.namespace}/tenant/subjects`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return response.data.subjects;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public getLevels(subjectId: any) {
        const endpoint = `${this.namespace}/tenant/subjects/${subjectId}/levels`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return response.data.levels;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public getTenants() {
        const endpoint = `${this.adminNamespace}/tenant?offset=0&limit=500`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return topicListSerializer.serializeTenantList(response.data.list);
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public createTopic(params: any) {
        const endpoint = `${this.namespace}/topics/create`;
        const header = http.getTokenHeaders();
        return http.post(endpoint, header, params).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public updateTopic(params: any, topicId: string) {
        params.marker_id = topicId;
        const endpoint = `${this.namespace}/topics/${topicId}`;
        const header = http.getTokenHeaders();
        return http.put(endpoint, header, params).then((response) => {
            return response.data;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public getMarkers(params: any) {
        const endpoint = `${this.markerNamespace}/markers?fw_code=${params.frameworkCode}&tx_subject_code=${params.subjectCode}`;
        const header = http.getTokenHeaders();
        return http.get(endpoint, header).then((response) => {
            return response.data.markers;
        }).catch((error: any) => {
            return { message: 'error' };
        });
    }

    public async deleteTopic(topicId: any) {
        const endpoint = `${this.namespace}/topics/delete/${topicId}`;
        const header = http.getTokenHeaders();    
        try {
            const response = await http.delete(endpoint, header);
            return response.data;
        } catch (error) {
            throw error; // let the caller handle the error
        }
    }
}

export const topicListAPI = TopicListAPI.instance;
